































import Vue from 'vue'
import * as qs from 'qs'

export default Vue.extend({
  name: 'EmailAuthentication',
  data() {
    return {
      pinCode: ''
    }
  },
  methods: {
    /**
     * メール認証する
     */
    async authenticateEmail(this: any) {
      try {
        await this.$http.post(
          '/notice_setting/',
          qs.stringify({
            page: 'pin_check',
            pin: this.pinCode
          })
        )
        await this.$_alert(
          'メールアドレスの登録が完了しました。',
          sessionStorage.getItem('email')
        )
        sessionStorage.removeItem('email')
        this.$router.replace('/notification/setting')
      } catch (err) {
        await this.$_alert(
          'メールアドレスの認証に失敗しました。もう一度お試しください。'
        )
        this.$router.replace('/notification/setting/email')
      }
    },

    /**
     * ページを戻って自動で Email 認証の再送を行う
     */
    resubmit() {
      this.$router.replace({
        name: 'notification/setting/email',
        params: { resubmit: 'true' }
      })
    }
  }
})
